<template>
  <div class="complex-wrap">
    <div style="font-size: 12px">拖动可调整顺序<BatchEditImages v-model="alibabaForm[key]" @change="onChange" refName="imgs" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
    <MutiImgUpload
      ref="imgs"
      :mainImgNums="0"
      :limitNums="extraAttr.limitNums || 5"
      :imgs="alibabaForm[key] || []"
      v-bind="extraAttr"
      :auditFileList="auditFileList"
      @change="onChange"
      @file-upload="handleImageUpload"
    />
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import storeMixins from '../store-mixins';

export default {
  components: {
    MutiImgUpload,
    BatchEditImages
  },
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name;
    },
    extraAttr() {
      return this.props.extraAttr || {};
    },
    auditFileList() {
      return this.$attrs.auditFileList;
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateAlibabaForm(newFormFields);
    },
    handleImageUpload(url) {
      this.$emit('file-upload', url);
    },
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
  },
  mounted() {
    const watcher = this.$watch(
      'extraAttr',
      v => {
        if (v._needLimit) {
          this.$parent.rules.push({
            validator: async (rule, value, callback) => {
              let errMsg = await this.$refs.imgs.method_validImage();
              if (errMsg) {
                callback(new Error(errMsg));
              } else {
                callback();
              }
            },
          });
        }
        this.$nextTick(() => {
          watcher && watcher();
        });
      },
      {
        immediate: true,
      }
    );
  },
};
</script>

<style lang="scss" scoped>
</style>